<ng-container *ngIf="visible">
  <ng-content></ng-content>
</ng-container>
